<template>
  <div>
    <!-- Navbar desktop screen -->

    <div class="desktop">
      <nav
        class="navbar navbar-expand-lg navbar-dark fixed-top desktop-style-nav"
        role="navigation"
        aria-label=""
      >
        <div class="container">
          <button
            class="navbar-toggler border-0"
            type="button"
            id="collapseNavBar"
            data-toggle="collapse"
            data-target="#exCollapsingNavbar"
          >
            &#9776;
          </button>
          <div
            class="collapse navbar-collapse navbar-sty"
            id="exCollapsingNavbar"
          >
            <ul class="nav navbar-nav navbar-style">
              <a href="#" class="nav-link" id="logoNav"
                ><img :src="logo" alt="logo-PB"
              /></a>

              <li
                class="nav-item"
                style="margin-left: 30px"
                @click="$router.push({ name: 'home' })"
              >
                <a
                  href="#"
                  class="nav-link nav-link-style"
                  v-bind:class="{
                    active: this.$store.state.navBarActive === 'boletos',
                  }"
                  id="navLinkBill"
                  >Boletos</a
                >
              </li>
              <!-- <li class="nav-item">
                <a
                  href="#"
                  id="navLinkInvoice"
                  class="nav-link nav-link-style"
                  v-bind:class="{ active: this.$store.state.navBarActive === 'faturas' }"
                  >Faturas</a
                >
              </li> -->
            </ul>
            <ul class="nav navbar-nav ml-auto">
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown"
                  href="#"
                  style="margin-right: 30px"
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <em class="fa fa-user-circle fa-user-style"></em>
                </a>

                <div class="dropdown-menu dropdown-menu-right">
                  <li class="dropdown-item top-card-user top-card">
                    <h6>Conta</h6>
                    <div class="items-edit-navbar">
                      <p>Login: {{ this.userLogin }}</p>
                      <p>E-mail: {{ this.userEmail }}</p>
                    </div>
                  </li>

                  <li class="dropdown-item item-dropdown-cursor">
                    <button
                      class="btn btn-light btn-background-color"
                      id="tutorialVideo"
                      data-toggle="modal"
                      data-target="#firstStepVideo"
                    >
                      <em class="fa fa-video-camera fa-user-style-menu"> </em>
                      <span> Primeiros passos </span>
                    </button>
                  </li>

                  <li
                    class="dropdown-item item-dropdown-cursor"
                    data-toggle="modal"
                    data-target="#changePasswordModal"
                    @click="renderChangePassword += 1"
                  >
                    <button
                      class="btn btn-light btn-background-color"
                      id="changePasswordButton"
                    >
                      <em class="fa fa-key fa-user-style-menu"> </em>
                      <span> Alterar senha </span>
                    </button>
                  </li>
                  <li
                    class="dropdown-item item-dropdown-cursor"
                    @click="$router.push({ name: 'RegisteredPayerUser' })"
                    v-if="userProfile === 5"
                  >
                    <button
                      type="button"
                      class="btn btn-light btn-background-color"
                      id="userPayerButton"
                    >
                      <em class="fa fa-users fa-user-style-menu"> </em>
                      <span> Usuário pagador</span>
                    </button>
                  </li>
                  <li
                    class="dropdown-item item-dropdown-cursor"
                    data-toggle="modal"
                    data-target="#editMyProfile"
                    @click="renderEditMyProfile += 1"
                  >
                    <button
                      class="btn btn-light btn-background-color"
                      id="myProfileButton"
                    >
                      <em
                        class="fa fa-user fa-user-style-menu"
                        style="margin-left: 5px"
                      >
                      </em>
                      <span> Meu perfil </span>
                    </button>
                  </li>
                  <li
                    class="dropdown-item item-dropdown-cursor"
                    @click="$router.push({ name: 'MyUsers' })"
                    v-if="userProfile === 5"
                  >
                    <button
                      class="btn btn-light btn-background-color"
                      id="myUserButton"
                    >
                      <em class="fa fa-users fa-user-style-menu"> </em>
                      <span> Meus sacados </span>
                    </button>
                  </li>
                  <li
                    v-if="showCallCenter"
                    class="dropdown-item item-dropdown-cursor"
                    @click="$router.push({ name: 'CallCenter' })"
                  >
                    <button
                      type="button"
                      class="btn btn-light btn-background-color"
                      id="callCenterButton"
                    >
                      <em class="fa fa-comments fa-user-style-menu"> </em>
                      <span> Atendimento </span>
                    </button>
                  </li>
                  <li
                    class="dropdown-item item-dropdown-cursor"
                    @click="logout"
                  >
                    <button
                      type="button"
                      class="btn btn-light btn-background-color"
                      id="logoutButton"
                    >
                      <em class="fa fa-sign-out fa-user-style-menu"></em>
                      <span> Sair </span>
                    </button>
                  </li>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
    <!-- Navbar mobile screen -->

    <div class="mobile">
      <nav
        class="navbar navbar-expand-lg navbar-light desktop-style-nav"
        aria-label=""
      >
        <a class="navbar-brand" href="#"
          ><img
            style="width: 190px; margin-left: 15px"
            :src="logo"
            alt="image-logo"
        /></a>
        <button
          class="navbar-toggler"
          style="border: none; margin-right: 15px; font-size: 30px"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="main" role="main">
            <div class="gallery" aria-label="gallery">
              <li
                class="gallery__item"
                data-toggle="modal"
                data-target="#editMyProfile"
                @click="renderEditMyProfile += 1"
              >
                <em class="fa fa-user icons"></em>
                <div class="button-style">Meu perfil</div>
              </li>
              <li
                class="gallery__item"
                data-toggle="modal"
                data-target="#firstStepVideo"
              >
                <em class="fa fa-video-camera icons"> </em>
                <div class="button-style">Primeiros passos</div>
              </li>

              <li
                class="gallery__item"
                data-toggle="modal"
                data-target="#changePasswordModal"
                @click="renderChangePassword += 1"
              >
                <em class="fa fa-key icons"></em>
                <div class="button-style">Alterar senha</div>
              </li>
              <li
                class="gallery__item"
                @click="$router.push({ name: 'RegisteredPayerUser' })"
                v-if="userProfile === 5"
              >
                <em class="fa fa-users icons"></em>
                <div class="button-style">Usuário Pagador</div>
              </li>
              <li
                class="gallery__item"
                v-if="showCallCenter"
                @click="$router.push({ name: 'CallCenter' })"
              >
                <em class="fa fa-comments icons"></em>
                <div class="button-style">Atendimento</div>
              </li>
              <!-- <li class="gallery__item">
                <em class="fa fa-copy fa icons"></em>
                <div class="button-style">Faturas</div>
              </li> -->

              <li class="gallery__item" @click="$router.push({ name: 'home' })">
                <em class="fa fa-copy icons"></em>
                <div class="button-style">Boletos</div>
              </li>
              <!-- <li
                class="gallery__item"
                @click="$router.push({ name: 'MyUsers' })"
                v-if="userProfile === 5"
              > -->
              <li
                class="gallery__item"
                @click="$router.push({ name: 'MyUsers' })"
                v-if="userProfile === 5"
              >
                <em class="fa fa-users icons"></em>
                <div class="button-style">Meus sacados</div>
              </li>

              <li class="gallery__item" @click="logout">
                <em class="fa fa-sign-out icons"></em>
                <div class="button-style">Sair</div>
              </li>
            </div>
          </ul>
        </div>
      </nav>
    </div>
    <first-step-video></first-step-video>
    <change-password :key="renderChangePassword"></change-password>
    <my-profile :key="renderEditMyProfile"></my-profile>
    <cookies-consent></cookies-consent>
    <privacy-policy-consent></privacy-policy-consent>
    <banner v-if="showBanners" v-bind:banners="banners"></banner>
  </div>
</template>

<script>
import axios from "axios";
import ChangePassword from "../../views/components/changePassword/ChangePassword";
import CookiesConsent from "./CookiesConsent";
import PrivacyPolicyConsent from "./PrivacyPolicyConsent";
import Banner from "./Banner";
import MyProfile from "../../views/components/myprofile/MyProfile";
import FirstStepVideo from "../../views/components/firstStep/FirstStepVideo";

export default {
  components: {
    ChangePassword,
    CookiesConsent,
    PrivacyPolicyConsent,
    MyProfile,
    Banner,
    FirstStepVideo,
  },
  name: "NavBar",
  data() {
    return {
      userLogin: "",
      userEmail: "",
      userProfile: "",
      renderChangePassword: Math.random(),
      renderEditMyProfile: Math.random(),
      showCallCenter: false,
      isActive: false,
      isActiveBill: false,
      banners: [],
      showBanners: false,
      logo:
        localStorage.logoVazado !== "false"
          ? localStorage.logoVazado
          : localStorage.logo,
      colorSkins: "colordefault",
    };
  },
  mounted() {
    let userLogged = JSON.parse(localStorage.userLogged);
    this.userLogin = userLogged.usu_login;
    this.userEmail = userLogged.usu_email;
    this.userProfile = userLogged.per_id;

    axios
      .get(`${process.env.API_PBM}/accept/check`)
      .then((responseData) => {
        this.$store.state.showAccepts = [];
        let accepts = ['cookies', 'privacy']
        for (let index in accepts) {
          if (!responseData.data.data[`${accepts[index]}Policy`]){
            this.$store.state.showAccepts.push(accepts[index])
          }
        }
        $(`#${this.$store.state.showAccepts[0]}modal`).show();
      });
    axios.get(`${process.env.API_PBM}/user/banner`).then((response) => {
      if (response.data.data.user_banner.length > 0) {
        response.data.data.user_banner.forEach((element) => {
          this.banners.push(element);
        });
      }
      if (response.data.data.group_banner.length > 0) {
        response.data.data.group_banner.forEach((element) => {
          this.banners.push(element);
        });
      }
      if (this.banners.length) return (this.showBanners = true);
    });

    axios.get(`${process.env.API_PBM}/helpDesk/show`).then((response) => {
      if (response.data.data) {
        this.showCallCenter = true;
      }
    });
    if (localStorage.themeColor) {
      this.colorSkins = localStorage.themeColor;
    }
    this.appendFile(this.colorSkins);
  },

  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    logout: function () {
      this.$store.dispatch("logout").then(() => {
        this.$router
          .push({ path: localStorage.getItem("group") })
          .catch(() => {});
      });
    },
    appendFile(color) {
      let file = document.createElement("link");
      file.rel = "stylesheet";
      file.href = `static/css/colorSkins/${color}.css`;
      document.head.appendChild(file);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
* {
  padding: 0px;
}

.btn-light {
  background: #fff !important;
  border: none !important;
  cursor: pointer;
  width: 100%;
  text-align: left;
}

.navbar-style {
  line-height: 60px;
  margin-left: 30px;
}
.nav-bar a {
  color: #fff !important;
}

.nav-link-style:hover {
  color: #fff !important;
}
.active {
  color: #fff !important;
}

.fa-user-style {
  font-size: 25px;
  color: #fff !important;
}
.fa-user-style-menu {
  font-size: 19px;
  margin-right: 10px;
  color: rgb(100, 95, 95) !important;
}

.top-card-user {
  color: #fff;
  border-radius: 12px 12px 0px 0px;
}

.btn-background-color {
  color: rgb(100, 95, 95) !important;
  font-size: 15px;
  margin-top: -10px;
}

img {
  width: 170px;
}
.dropdown-menu {
  border: none;
  padding: 0;
  font-size: 14px;
  padding: 0;
  margin: 0;
  box-shadow: 0px 0px 4px;
  border-radius: 12px;
  color: rgb(100, 95, 95) !important;
}
.dropdown-menu li {
  padding: 5px;
}

.item-dropdown-cursor {
  background-color: #fff;
  color: rgb(96, 95, 100);
  cursor: pointer;
  border-radius: 12px;
}
.card {
  border: none !important;
}
.items-edit-navbar {
  font-size: 12px;
}

@media only screen and (max-width: 991px) {
  .mobile {
    display: block !important;
  }
  .desktop {
    display: none !important;
  }

  .navbar {
    line-height: 3.5rem;
  }

  body {
    background-color: #d7d7d7;
    font-family: "Roboto";
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .main {
    padding: 20px;
  }

  .fa {
    font-size: 60px;
    display: flex;
    justify-content: center;
    margin-top: -65px;
    color: rgb(136, 130, 130);
  }

  .gallery {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    grid-auto-rows: 130px;
    grid-gap: 20px;
    list-style-type: none;
    cursor: pointer;
  }
  .gallery__item {
    height: 100%;
    background-color: #d8d8d8;
    padding-top: 90px;
  }

  .button-style {
    background-color: #d7d7d7;
    color: rgb(136, 130, 130);
    width: 100%;
    font-size: 14px;
    text-align: center;
  }
}

.mobile {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/common/components/NavBar.vue